import React from "react";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { languages } from "../../constants/languages";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import DefaultFases from "../../constants/DefaultFases";
import Button from "@material-ui/core/Button";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

class PlayerRankingTable extends React.Component {
  render() {
    let phases =
      (this.props.divisionsObject[this.props.division] || {}).fases ||
      DefaultFases;
    let phaseKeys = Object.keys(phases);

    const playerPointsPlayedKey = Object.keys(
      this.props.tournament.playerPoints || {}
    ).find((p) => this.props.tournament.playerPoints[p].type === "3");

    return (
      <div style={{ marginTop: 5, overflowX: "auto" }}>
        {phaseKeys.length > 1 && (
          <div>
            <Button
              size="small"
              variant="outlined"
              color="default"
              onClick={this.props.handleMenuPhase}
              style={{ marginRight: 10 }}
              endIcon={<KeyboardArrowDownIcon />}
            >
              {this.props.selectedPhase === "all"
                ? languages.results.allPhases
                : (phases[this.props.selectedPhase] || {}).name || ""}
            </Button>
            <Menu
              id="menu-phases"
              anchorEl={this.props.anchorElPhase}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              getContentAnchorEl={null}
              open={Boolean(this.props.anchorElPhase)}
              onClose={this.props.handleClosePhase}
            >
              <MenuItem
                selected={this.props.selectedPhase === "all"}
                onClick={() => {
                  this.props.selectPhase("all");
                }}
                // style={{ paddingRight: 50 }}
              >
                {languages.results.allPhases}
              </MenuItem>
              {phaseKeys.map((phaseKey) => {
                let phase = phases[phaseKey];
                return (
                  <MenuItem
                    key={phaseKey}
                    selected={this.props.selectedPhase === phaseKey}
                    onClick={() => {
                      this.props.selectPhase(phaseKey);
                    }}
                    // style={{ paddingRight: 50 }}
                  >
                    {phase.name || ""}
                  </MenuItem>
                );
              })}
            </Menu>
          </div>
        )}
        <Table style={{ minWidth: 500 }}>
          <TableHead>
            <TableRow>
              <TableCell style={{ paddingRight: 30 }}>#</TableCell>
              <TableCell style={{ padding: 0 }}>
                {languages.teams.player}
              </TableCell>
              {playerPointsPlayedKey && (
                <TableCell
                  style={{
                    minWidth: 30,
                    paddingRight: 0,
                    fontWeight:
                      this.props.sort === playerPointsPlayedKey
                        ? "bold"
                        : "normal",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    this.props.handleSortChange(e, playerPointsPlayedKey);
                  }}
                >
                  {
                    this.props.tournament.playerPoints[playerPointsPlayedKey]
                      .abbr
                  }
                </TableCell>
              )}
              {Object.keys(this.props.tournament.playerPoints || {}).map(
                (p) => {
                  let points = this.props.tournament.playerPoints[p];
                  if (points.type !== "3") {
                    return (
                      <TableCell
                        key={p}
                        style={{
                          minWidth: 30,
                          paddingRight: 0,
                          fontWeight:
                            this.props.sort === (p === "0" ? "g" : p)
                              ? "bold"
                              : "normal",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          this.props.handleSortChange(e, p === "0" ? "g" : p);
                        }}
                      >
                        {points.abbr}
                      </TableCell>
                    );
                  } else {
                    return null;
                  }
                }
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.ranking.map((ranking, i) => {
              return (
                <TableRow key={this.props.division + i}>
                  <TableCell style={{ paddingRight: 30 }}>
                    {!ranking.hideRank && i + 1 + "."}
                  </TableCell>
                  <TableCell style={{ padding: 0, minWidth: 120 }}>
                    {ranking.name}
                  </TableCell>
                  {playerPointsPlayedKey && (
                    <TableCell style={{ minWidth: 30, paddingRight: 0 }}>
                      {ranking[playerPointsPlayedKey] || 0}
                    </TableCell>
                  )}
                  {Object.keys(this.props.tournament.playerPoints || {}).map(
                    (p) => {
                      let playerPoints = this.props.tournament.playerPoints[p];
                      if (playerPoints.type !== "3") {
                        let points = ranking[p === "0" ? "g" : p] || 0;
                        return (
                          <TableCell
                            key={p}
                            style={{ minWidth: 30, paddingRight: 0 }}
                          >
                            {points}
                          </TableCell>
                        );
                      } else {
                        return null;
                      }
                    }
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default PlayerRankingTable;
